import { forwardRef, type InputHTMLAttributes } from "react";

interface TermsCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

const TermsCheckbox = forwardRef<HTMLInputElement, TermsCheckboxProps>(
  function TermsCheckbox({ error, ...rest }, ref) {
    return (
      <div className="space-y-1">
        <label className="flex items-start gap-2 text-sm">
          <input
            ref={ref}
            type="checkbox"
            className="mt-1 h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
            {...rest}
          />
          <span className="text-muted-foreground">
            Acepto los{" "}
            <a
              href="/terminos"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary underline hover:no-underline"
            >
              Términos y Condiciones
            </a>{" "}
            y la{" "}
            <a
              href="/privacidad"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary underline hover:no-underline"
            >
              Política de Privacidad
            </a>
            . Entiendo que las certificaciones son privadas, y que no hay
            devoluciones una vez habilitado el acceso, salvo excepción legal o
            autorización expresa.
          </span>
        </label>
        {error ? <p className="text-xs text-red-600">{error}</p> : null}
      </div>
    );
  },
);

export default TermsCheckbox;
